import { useMemo } from 'react'
import { Button } from '../../../Button'

import { Form, FormCheckbox, FormHeader, FormItem, FormSelect, FormText } from '../../form'

import { Filter } from '../../../Filter'

/** @param {import('./CustomChartForm.types.js').CustomChartFormProps} props */
export const CustomChartForm = ({ config, setConfig, formData }) => {
  // we want the user to be able to select no filter which is effectively the label 'Overall Grading'
  const groupByItems = useMemo(() => {
    return [{ label: 'Overall Grading', value: '' }, ...formData.groupBy]
  }, [formData])
  return (
    <Form>
      <FormHeader>Grading Graph Block</FormHeader>
      <FormText label='Title' value={config?.title || ''} onChange={(title) => setConfig({ ...config, title })} />
      <FormSelect
        label='Grading for:'
        items={groupByItems}
        value={config.groupBy}
        getItemLabel={(item) => item.label}
        getItemValue={(item) => item.value}
        onSelect={(value) => {
          const item = groupByItems.find((i) => i.value === value)
          setConfig({
            ...config,
            groupBy: value ? value : undefined,
            title: item ? item.label : config.title
          })
        }}
      />
      <FormCheckbox label='Display detailed graph data' checked={config?.legend || false} onChange={(checked) => setConfig({ ...config, legend: checked })} />
      <FormItem>
        <Button
          type='primary'
          onClick={() => {
            // Grab and add to filters.
            const filters = config?.filters || []
            filters.push({})

            // Set state.
            setConfig({
              ...config,
              filters
            })
          }}
        >
          Add Filter
        </Button>

        {config?.filters?.length
          ? config.filters.map((filter, index) => {
              return (
                <Filter
                  key={index}
                  config={formData.filters}
                  value={filter}
                  onChange={(val) => {
                    // Update filters
                    const filters = config.filters
                    filters[index] = val

                    // Save.
                    setConfig({
                      ...config,
                      filters
                    })
                  }}
                  onRemove={() => {
                    setConfig({
                      ...config,
                      filters: [...config.filters.slice(0, index), ...config.filters.slice(index + 1)]
                    })
                  }}
                />
              )
            })
          : ''}
      </FormItem>
    </Form>
  )
}
